import styled from 'styled-components';

import { spinner } from '../../styles/mixins';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  margin-top: 2rem;
`;

const Spinner = styled.div`
  border: 3px solid var(--border);
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  ${spinner}
`;

const LoadingText = styled.p`
  margin-top: 1rem;
  color: var(--ink-faint);
  font-size: 1.4rem;
  text-align: center;
`;

export { Container, LoadingText, Spinner };
